<template>
  <div class="intro-section">
    <container class="container">
      <div class="logo-holder">
        <img
          :src="require(`@/assets/img/nosop3.svg`)"
          class="logo">
      </div>
      <div class="intro-container">
        <div class="title-holder">
          <h1 class="title">{{ content.title }}</h1>
          <!-- <h3 class="subtitle">{{ content.subtitle }}</h3> -->
        </div>
        <div
          class="text"
          v-html="content.text" />
        <alert />
      </div>
    </container>
  </div>
</template>
<script>

import TextComponent from 'components/TextComponent';
import VideoComponent from 'components/VideoComponent';
import Container from 'components/Container';
import Alert from 'components/Alert';

export default {
  components: {
    TextComponent,
    VideoComponent,
    Container,
    Alert,
  },
  props: {
    content: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .intro-section {
    width: 100%;
    min-height: 100vh;
    position: relative;
    background-image: url('../assets/img/teheran.jpg');
    background-position: top center;
    background-size: cover;
    z-index: 9;

    @include tablet {
      margin-bottom: 100px;
    }
  }

  .logo-holder {
    text-align: center;
    @include bigmobile {
      margin-top: 50px;
    }
  }
  .logo {
    width: 90px;
  }

  .intro-container {
    display: flex;
    min-height: 80vh;
    padding: 0;
    max-width: 300px;
    margin: auto;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    width: 200px;
    text-align: center;
    line-height: 36px;
    color: black;

    @include bigmobile {
      margin-top: 60px;
    }
  }
  .subtitle {
    color: black;
  }
  .text {
    max-width: 300px;
    padding: 0 30px;
    color: black;
    font-weight: bold;
    text-align: center;

    @media screen and (min-width: 460px) and (orientation: portrait) {
      margin-top: -100px;
    }

    @include tablet {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IntroSection.vue